import Stack from '@liquidweb-dev/undercurrent/Stack';
import HistoryIcon from '@liquidweb-dev/undercurrent/icons/lucide/History';
import BrickWallIcon from '@liquidweb-dev/undercurrent/icons/lucide/BrickWall';
import SlidersVerticalIcon from '@liquidweb-dev/undercurrent/icons/lucide/SlidersVertical';
import Button from '@liquidweb-dev/undercurrent/Button';
import HelpDocCard from './HelpDocCard';

const CloudMetalServerDetails = () => {
	return (
		<Stack
			sx={{
				gap: 200,
			}}
		>
			<HelpDocCard
				title="Creating a Backup"
				description="Learn how to create and manage backups easily"
				link="https://docs.nexcess.com/hosting/hosting-services/cloud-vps/cloud-vps-backups/creating-a-backup-of-your-cloud-vps/"
				icon={HistoryIcon}
			/>
			<HelpDocCard
				title="Configuring Your Firewall"
				description="Control access by setting up custom firewall rules"
				link="https://docs.nexcess.com/hosting/security/firewall-management/cloud-firewall/configuring-your-cloud-firewall/"
				icon={BrickWallIcon}
			/>
			<HelpDocCard
				title="Login to your control panel"
				description="Checkout how to easily access your control panel like Plesk, Interworx, or WHM"
				icon={SlidersVerticalIcon}
				link="https://docs.nexcess.com/log-into-your-control-panel/"
			/>
			<Button
				variant="ghost"
				size="large"
				sx={() => ({ paddingY: 100 })}
				href="https://docs.nexcess.com"
				component="a"
				target="_blank"
				rel="noopener"
			>
				See all Help Docs
			</Button>
		</Stack>
	);
};

export default CloudMetalServerDetails;
